/**
 * Created by sagardesai on 11/07/18.
 */

import * as types from "../../actions/types/index";
import {setInitialState} from "../../util/utility";

const INITIAL_STATE = setInitialState({
    payload: null,
});

export default function (state = INITIAL_STATE, action) {

    switch (action.type) {
        case types.BLOCK_UNBLOCK_VIEWER_REQUEST:
            return {
                ...state,
                isFetching: true,
            };
        case types.BLOCK_UNBLOCK_VIEWER_RECEIVE:
            return {
                ...state,
                isFetching: false,
                isSuccess: true,
                payload: action.payload
            };
        case types.BLOCK_UNBLOCK_VIEWER_FAILURE:
            return {
                ...state,
                isFetching: false,
                isError: true,
                payload: action.payload.response.error,
            };
        case types.RESET_BLOCK_UNBLOCK_VIEWER:
            return {
                ...state,
                payload: action.payload,
            };
        default:
            return {
                ...state
            }
    }
}